export default "__VITE_ASSET__Col3Zovl__"